import { RecurrencePattern, RecurrenceCalculationType } from "@/lib/api/checklist";

interface RecurrenceDisplayProps {
  pattern?: RecurrencePattern;
  interval?: number;
  calculationType?: RecurrenceCalculationType;
}

export function RecurrenceDisplay({ 
  pattern, 
  interval = 1, 
  calculationType = RecurrenceCalculationType.FIXED_SCHEDULE 
}: RecurrenceDisplayProps) {
  if (!pattern) {
    return <span className="text-muted-foreground">Not Recurring</span>;
  }

  const getPatternText = (pattern: RecurrencePattern, interval: number) => {
    const intervalText = interval > 1 ? `${interval} ` : "";
    
    switch (pattern) {
      case RecurrencePattern.DAILY:
        return `Every ${intervalText}${interval > 1 ? "days" : "day"}`;
      case RecurrencePattern.WEEKLY:
        return `Every ${intervalText}${interval > 1 ? "weeks" : "week"}`;
      case RecurrencePattern.MONTHLY:
        return `Every ${intervalText}${interval > 1 ? "months" : "month"}`;
      case RecurrencePattern.QUARTERLY:
        return `Every ${intervalText}${interval > 1 ? "quarters" : "quarter"}`;
      case RecurrencePattern.BIANNUALLY:
        return `Every ${intervalText}${interval > 1 ? "half-years" : "half-year"}`;
      case RecurrencePattern.ANNUALLY:
        return `Every ${intervalText}${interval > 1 ? "years" : "year"}`;
      default:
        return pattern;
    }
  };

  const calculationTypeText = calculationType === RecurrenceCalculationType.FROM_COMPLETION
    ? " (from completion)"
    : "";

  return (
    <span className="text-sm">
      {getPatternText(pattern, interval)}{calculationTypeText}
    </span>
  );
}
